import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import SEOStructuredData from './components/feature/SEOStructuredData';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <SEOStructuredData />
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
